import { render, staticRenderFns } from "./providelist.vue?vue&type=template&id=b7239dd8&scoped=true"
import script from "./providelist.vue?vue&type=script&lang=js"
export * from "./providelist.vue?vue&type=script&lang=js"
import style0 from "./providelist.vue?vue&type=style&index=0&id=b7239dd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7239dd8",
  null
  
)

export default component.exports